import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  height: 94px;
  background-color: #333;
  color: #fff;
  position: fixed;
  width: 100vw;
  z-index: 1;
  display: flex;
  justify-content: center;
  transition: all 0.45s ease-in-out;
  box-shadow: ${(props) => props.active && "0 4px 40px rgba(0, 0, 0, 0.15)"};

  ${mediaMaxWidth.smallDesktop`
    height: 48px;
  `}

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.85s;
    animation-fill-mode: both;
  }
`;

export const Inner = styled.div`
  max-width: ${(props) => !props.isIe && "1440px"};
  width: ${(props) => props.isIe && "95vw"};
  display: flex;
  align-items: center;
  flex: 1;
`;

export const LogoLink = styled.a``;

export const Logo = styled.img`
  width: 250px;

  ${mediaMaxWidth.smallDesktop`
    width: 165px;
  `}
`;

export const Links = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  margin: 0 15px;

  ${mediaMaxWidth.smallDesktop`
    display: none;
  `}
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Link = styled.a`
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  padding: 0 22px;

  ${mediaMaxWidth.mediumDesktop`
    padding: 0 12px;
  `}
`;

export const ButtonLink = styled.a`
  background-color: transparent;
  color: #fff;
  display: inline-block;
  border: 2px solid #c7c7c7;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  padding: 12px 15px;
  max-width: 180px;
  text-align: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin: 0 20px;

  &:hover {
    border: 2px solid #f2008c;
    color: #f2008c;
  }
`;

export const MobileMenuTrigger = styled.div`
  position: fixed;
  top: 11px;
  right: 15px;
  z-index: 2;

  svg {
    color: #f2008c;
    font-size: 1.6em;
  }

  ${mediaMinWidth.smallDesktop`
    display: none;
  `}
`;

export const MobileMenu = styled.div`
  ${mediaMinWidth.smallDesktop`
    display: none;
  `}
`;

export const MobileMenuContent = styled.div`
  height: 340px;
  z-index: 1;
  background-color: #333;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.25);
  transition: all 0.45s ease-in-out;
  position: fixed;
  top: ${(props) => (props.active ? "48px" : "-100vh")};
  left: 0;
  width: calc(100vw - 30px);
  padding: 15px;

  svg {
    color: #f2008c;
    font-size: 1.6em;
  }
`;

export const MobileLinks = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const MobileLink = styled.a`
  padding: 12px 0;
  font-size: 1.125em;
  color: #fff;
  text-decoration: none;
`;

export const MobileButtonLink = styled.a`
  background-color: transparent;
  color: #fff;
  display: inline-block;
  border: 2px solid #c7c7c7;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  padding: 12px 15px;
  max-width: 100px;
  text-align: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin: 12px 0;
`;
